import axios from "axios"
// const token=window.location.search.toString()
// const tokenString=token.slice(6)
// console.log(tokenString)


const lawService = {}
lawService.authUser = (code) => {
    const config = {
        method: "GET",
        url:`https://inheritguard.onrender.com/api/oauth/token/${code}`,
        data: null,
        crossdomain: true,
        header: { "Content-Type": "application/json" },
    };
    return axios(config)
};
//lawService.authUser("b8JoFpv4xfj-k8j9qlmocGAbZcZn_OOL2GmEjiwWhMU")
	// .then((r)=>{onAuthorizationSuccess(r)})
  // .catch((e)=>{onAuthorizationFail(e)})

lawService.markPayment= async (id)=>{
    try{
      const config={
        url:`https://inheritguard.onrender.com/api/v1/prospects/markPayment/${id}`,
        data:{
           "custom_fields": [
                {
                    "id": "459565",
                    "value": true
                }
            ]
        },
        method:"get"
      }
     
    const testo= await axios(config)
    console.log(testo)
    }
    catch(error){
        //res.status(500).json({error})
        
    }
  }
  lawService.getMatterByEmail= async (email)=>{
   const config={
        url:`https://inheritguard.onrender.com/api/v1/prospects/find_by_email/${email}`,
        // url:`http://localhost:5000/api/v1/prospects/find_by_email/${email}`,
        method:"get"
      }
     
    return axios(config)
  
     
  }
 lawService.getAttorneyById=async(id)=>{
  const config={
    url:`https://inheritguard.onrender.com/api/v1/users/${id}`,
    method:"get"
  }
 
  const apiRes= await axios(config)
  const fName=apiRes.data.data.attributes.first_name
  const lName=apiRes.data.data.attributes.last_name
  let attorneyName=`${fName} ${lName}`
  return attorneyName
}
lawService.pushSimpleQuants=async(id,binderNumber,deedNumber,assignNumber,familyNumber,trustNumber,agentPlan,notary,paymentNote,actualValue,recordingNumber,deedsToBeDrafted,agentTrust,ammendNumber,purchasedNotaries,affidavitNumber,depositAmount,summer50,trustPlusNumber,isEPS,attorneyReviewNumber,trustPlusTag,agentAttend)=>{
  const config={
    url:`https://inheritguard.onrender.com/api/v1/prospects/pushSimpleAmounts/${id}/${binderNumber}/${deedNumber}/${assignNumber}/${familyNumber}/${trustNumber}/${agentPlan}/${notary}/${paymentNote}/${actualValue}/${recordingNumber}/${deedsToBeDrafted}/${agentTrust}/${ammendNumber}/${purchasedNotaries}/${affidavitNumber}/${depositAmount}/${summer50}/${trustPlusNumber}/${isEPS}/${attorneyReviewNumber}/${trustPlusTag}/${agentAttend}`,
   //url:`http://localhost:5000/api/v1/prospects/pushSimpleAmounts/${id}/${binderNumber}/${deedNumber}/${assignNumber}/${familyNumber}/${trustNumber}/${agentPlan}/${notary}/${paymentNote}/${actualValue}/${recordingNumber}/${deedsToBeDrafted}/${agentTrust}/${ammendNumber}/${purchasedNotaries}/${affidavitNumber}/${depositAmount}/${summer50}/${trustPlusNumber}/${isEPS}/${attorneyReviewNumber}/${trustPlusTag}/${agentAttend}`,
    method:"get"
  }
 
  const apiRes= await axios(config)
  console.log(apiRes)
}
lawService.pushSimpleQuants2=async(id,binderNumber,deedNumber,assignNumber,familyNumber,trustNumber,agentPlan,notary,paymentNote,actualValue,recordingNumber,deedsToBeDrafted,agentTrust,ammendNumber,purchasedNotaries,affidavitNumber,depositAmount,summer50,trustPlusNumber,isEPS,attorneyReviewNumber,trustPlusTag,agentAttend)=>{
  const config={
  url:`https://inheritguard.onrender.com/api/v2/prospects/pushSimpleAmounts`,
  //url:`http://localhost:5000/api/v2/prospects/pushSimpleAmounts`,
    method:"post",
    data:{
      
    }
  }
 
  const apiRes= await axios(config)
  console.log(apiRes)
}

lawService.getAllAttorneys=async(page)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/users/getAttorneys/${page}`,
    data: null,
    crossdomain: true
};
return axios(config)
}
lawService.changeAttorney=async(matterId,attorneyId)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/updateAttorney/${matterId}/${attorneyId}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.createIGNTransaction=async(transactionObj)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/createIGNTransaction/${transactionObj.transactable_id}/${transactionObj.payment_method}/${transactionObj.amount_cents}/${transactionObj.note}`,
   // url:`http://localhost:5000/api/v1/prospects/createIGNTransaction/${transactionObj.transactable_id}/${transactionObj.payment_method}/${transactionObj.amount_cents}/${transactionObj.note}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.createIGNTimeEntry=async(timeEntryObj)=>{
  const config = {
    method: "GET",
   url:`https://inheritguard.onrender.com/api/v1/prospects/createIGNTimeEntry/${timeEntryObj.contactable_id}/${timeEntryObj.description}/${timeEntryObj.rate_flat_fee}`,
   // url:`http://localhost:5000/api/v1/prospects/createIGNTimeEntry/${timeEntryObj.contactable_id}/${timeEntryObj.description}/${timeEntryObj.rate_flat_fee}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.updateIGNTimeEntry=async(entryObj)=>{
  const config = {
    method: "GET",
   url:`https://inheritguard.onrender.com/api/v1/prospects/updateIGNTimeEntry/${entryObj.timeEntryId}/${entryObj.matterId}/${entryObj.rate}`,
   // url:`http://localhost:5000/api/v1/prospects/updateIGNTimeEntry/${entryObj.timeEntryId}/${entryObj.matterId}/${entryObj.rate}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.get2k=async()=>{
  const config = {
    method: "GET",
   //url:`https://inheritguard.onrender.com/api/v1/prospects/updateIGNTimeEntry/${entryObj.timeEntryId}/${entryObj.matterId}/${entryObj.rate}`,
    url:`http://localhost:5000/api/v1/2kform`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.createMatter=async(firstName,lastName,email,phone,actualValue,trustPlus,notes)=>{
  const config = {
    method: "post",
   url:`https://inheritguard.onrender.com/api/v1/createMatter`,
   // url:`http://localhost:5000/api/v1/createMatter`,
    data: {
        "first_name":firstName,
        "last_name":lastName,
        "email":email,
        "phone":phone,
        actualValue:actualValue,
        trustPlusNumber:trustPlus,
        note:notes,
      },
    crossdomain: true,
};
return axios(config)
}

lawService.detachTags=async(matterId,tags)=>{
  const config = {
    method: "POST",
   url:`https://inheritguard.onrender.com/api/v2/detachTags`,
    //url:`http://localhost:5000/api/v2/detachTags`,
    data: {matterId:matterId,tags:tags},
    crossdomain: true,
};
return axios(config)
}

lawService.getContactById=async(contactId)=>{
  const config = {
    method: "get",
   url:`https://inheritguard.onrender.com/api/v1/contacts/getContactById/${contactId}`,
    //url:`http://localhost:5000/api/v1/contacts/getContactById/${contactId}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.getMattersByAgentId=async(agentId)=>{
  const config = {
    method: "get",
   url:`https://inheritguard.onrender.com/api/v1/prospects/getMatterByAgentId/${agentId}`,
    //url:`http://localhost:5000/api/v1/prospects/getMatterByAgentId/${agentId}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.markInheritgold=async(agentId)=>{
  const config = {
    method: "get",
   url:`https://inheritguard.onrender.com/api/v1/contacts/markInheritgoldStatus/${agentId}`,
   // url:`http://localhost:5000/api/v1/contacts/markInheritgoldStatus/${agentId}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}
// const onAuthorizationSuccess=(r)=>{
//   console.log(r)
// }

// const onAuthorizationFail=(e)=>{
//   console.log(e)
//   // alert("Authorization Failed\nYou now be redirected to log in.")
//   // window.location.href="https://app.lawmatics.com/oauth/authorize?client_id=CbWFrrdb4kZUx6mGULdvsim-0jyGdgmeZOqU7WdsA4U&redirect_uri=https://inheritguard.com/shopping-cart-wordpress-test-copy/&response_type=code"
// }

export default lawService